import { render } from "./RankingList.vue?vue&type=template&id=066fed5f&scoped=true"
import script from "./RankingList.vue?vue&type=script&lang=js"
export * from "./RankingList.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=066fed5f&scoped=true&lang=css&external"
import "./RankingList.vue?vue&type=style&index=1&id=066fed5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066fed5f"]])

export default __exports__